import {
    CalendarIcon,
    PhoneIcon,
    OfficeBuildingIcon,
    MailIcon,
    PencilAltIcon,
} from "@heroicons/vue/outline";

/**
 * Kategorie → Icon für Notizen (Thema 7).
 *
 * EINE Quelle für alle Stellen (Notizen-Seite und Übersichts-Box auf der
 * Wohnungs-Übersicht), damit die Icons nicht auseinanderlaufen. Neue
 * Kategorien ausschliesslich hier ergänzen.
 */
export const NOTE_ICONS = {
    meeting: CalendarIcon,
    call: PhoneIcon,
    site: OfficeBuildingIcon,
    email: MailIcon,
    note: PencilAltIcon,
};

export function noteIconFor(category) {
    return NOTE_ICONS[category] || NOTE_ICONS.note;
}
